import * as React from 'react';
import { useEffect, useState } from 'react';

const REASONS = ['Return of Lost Item', 'Return of Damaged Item', 'QoS Pickup', 'Other'];

interface ILaborException {
  reason?: string;
}

interface ILaborExceptionInputProps {
  laborException?: ILaborException;
  onCheck(value: boolean): void;
  onSelect(value: string): void;
}

export const LaborExceptionInput: React.FC<ILaborExceptionInputProps> = ({ laborException, onCheck, onSelect }) => {
  const [checked, setChecked] = useState<boolean>(() => !!laborException);
  const [reason, setReason] = useState<string>(() => laborException?.reason || '');

  useEffect(() => {
    if (laborException) {
      setChecked(true);
      setReason(laborException.reason || '');
    } else {
      setChecked(false);
      setReason('');
    }
  }, [laborException]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onCheck(newChecked);

    if (!newChecked) {
      setReason('');
    }
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newReason = event.target.value;
    setReason(newReason);
    onSelect(newReason);
  };

  return (
    <>
      <label htmlFor="labor-exception" className="control-label col-sm-2">
        Waive Labor?
      </label>
      <div className="col-sm-1 col-auto">
        <input type="checkbox" id="labor-exception" checked={checked} onChange={handleCheckboxChange} />
      </div>
      <div className="col-sm-9">
        <select className="form-control" disabled={!checked} value={reason} onChange={handleSelectChange}>
          <option value="">-- Reason --</option>
          {REASONS.map((reasonOption) => (
            <option key={reasonOption} value={reasonOption}>
              {reasonOption}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};
